import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = {
  key: 0,
  class: "col-12"
}
const _hoisted_3 = { class: "card shadow-sm" }
const _hoisted_4 = { class: "card-content p-2" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { key: 2 }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { key: 3 }
const _hoisted_12 = { key: 4 }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = {
  key: 1,
  class: "text-center"
}
const _hoisted_16 = {
  key: 1,
  class: "col-12"
}
const _hoisted_17 = {
  key: 2,
  class: "col-12"
}
const _hoisted_18 = { class: "card shadow-sm" }
const _hoisted_19 = { class: "card-content p-2" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { key: 1 }
const _hoisted_23 = { key: 2 }
const _hoisted_24 = { key: 3 }
const _hoisted_25 = { class: "mt-4" }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = {
  key: 1,
  class: "text-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_alerts = _resolveComponent("alerts")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.applications.length || (!_ctx.quote_requests.length && !_ctx.quotes.length))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _cache[6] || (_cache[6] = _createElementVNode("div", { class: "card-header text-white bg-secondary fw-bold" }, "Role Applications", -1)),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_alerts, { alerts: _ctx.alerts }, null, 8, ["alerts"]),
              (_ctx.applications.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.applications, (application) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: application.id,
                        class: "p-2"
                      }, [
                        _createElementVNode("div", null, [
                          _cache[0] || (_cache[0] = _createElementVNode("strong", null, "Application Submitted:", -1)),
                          _createTextVNode(" " + _toDisplayString(_ctx.moment(application.created_at).format('MM/DD/YY')), 1)
                        ]),
                        _createElementVNode("div", null, [
                          _cache[3] || (_cache[3] = _createElementVNode("strong", null, "Status: ", -1)),
                          (application.interview == null && application.interview_requests.length === 0)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_6, "Pending"))
                            : (application.interview_requests.length)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                                  _cache[1] || (_cache[1] = _createTextVNode("Interview Requested ")),
                                  _createElementVNode("button", {
                                    class: "btn btn-primary btn-xs",
                                    onClick: ($event: any) => (_ctx.router.push({name:'request',params:{request_id:application.interview_requests[0].id}}))
                                  }, "Respond", 8, _hoisted_8)
                                ]))
                              : (application.interview && !application.interview.is_complete)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                                    _cache[2] || (_cache[2] = _createTextVNode("Interview scheduled ")),
                                    _createElementVNode("button", {
                                      class: "btn btn-primary btn-xs",
                                      onClick: ($event: any) => (_ctx.router.push({name:'interview',params:{interview_id:application.interview.id}}))
                                    }, "View", 8, _hoisted_10)
                                  ]))
                                : (application.interview && application.interview.is_complete)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_11, "Under Review"))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_12, "Pending"))
                        ]),
                        _cache[4] || (_cache[4] = _createElementVNode("h4", null, "Role(s) Applied for:", -1)),
                        _createElementVNode("ul", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(application.user.user_roles, (user_role) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: user_role.id
                            }, [
                              (user_role.role_id == _ctx.UserRole.AUTHOR && user_role.partner_id == 1)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_13, "SP-ED "))
                                : (user_role.role_id == _ctx.UserRole.AUTHOR && user_role.partner_id == 28)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_14, "Simclusive "))
                                  : _createCommentVNode("", true),
                              _createTextVNode(_toDisplayString(user_role.role.name), 1)
                            ]))
                          }), 128))
                        ]),
                        _cache[5] || (_cache[5] = _createElementVNode("hr", null, null, -1))
                      ]))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_15, " You have no role applications at this time. "))
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.applications.length && (_ctx.quote_requests.length || _ctx.quotes.length))
      ? (_openBlock(), _createElementBlock("div", _hoisted_16, _cache[7] || (_cache[7] = [
          _createElementVNode("br", null, null, -1)
        ])))
      : _createCommentVNode("", true),
    (_ctx.quote_requests.length || _ctx.quotes.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _cache[12] || (_cache[12] = _createElementVNode("div", { class: "card-header text-white bg-secondary fw-bold" }, "Quote Requests", -1)),
            _createElementVNode("div", _hoisted_19, [
              (_ctx.quote_requests.length || _ctx.quotes.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.quote_requests, (quote_request) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: quote_request.id,
                        class: "p-2"
                      }, [
                        _createElementVNode("div", null, [
                          _cache[8] || (_cache[8] = _createElementVNode("strong", null, "Quote Request Submitted:", -1)),
                          _createTextVNode(" " + _toDisplayString(_ctx.moment(quote_request.created_at).format('MM/DD/YY')), 1)
                        ]),
                        _cache[9] || (_cache[9] = _createElementVNode("div", null, [
                          _createElementVNode("strong", null, "Status: "),
                          _createElementVNode("span", null, "Pending")
                        ], -1))
                      ]))
                    }), 128)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.quotes, (quote) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: quote.id,
                        class: "p-2"
                      }, [
                        _cache[11] || (_cache[11] = _createElementVNode("div", null, [
                          _createElementVNode("strong", null, "Quote Available")
                        ], -1)),
                        _createElementVNode("div", null, [
                          _cache[10] || (_cache[10] = _createElementVNode("strong", null, "Status: ", -1)),
                          (quote.is_rejected)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_21, "Rejected"))
                            : (!quote.is_agreement_signed && !quote.is_payment_made)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_22, "Document signing and Payment required"))
                              : (quote.is_agreement_signed && !quote.is_payment_made)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_23, "Payment required"))
                                : (_openBlock(), _createElementBlock("span", _hoisted_24, "Agreement finalized")),
                          _createElementVNode("div", _hoisted_25, [
                            _createElementVNode("button", {
                              class: "btn btn-primary btn-xs",
                              onClick: ($event: any) => (_ctx.router.push({name:'PartnerAgreement',params:{agreement_id:quote.id}}))
                            }, "View Quote", 8, _hoisted_26)
                          ])
                        ])
                      ]))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_27, " You have no quote requests at this time. "))
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}